<template>
  <div class="space-y-1">
    <label class="text-xs font-semibold text-slate-600">{{ label }}</label>
    <div class="flex items-center space-x-2">
      <select
        class="flex-1 border rounded px-2 py-2 text-sm"
        v-model.number="local.hora"
      >
        <option v-for="h in 12" :key="h" :value="h">{{ h }}</option>
      </select>
      <span class="text-slate-500">:</span>
      <select class="w-20 border rounded px-2 py-2 text-sm" v-model.number="local.minuto">
        <option :value="0">00</option>
        <option :value="15">15</option>
        <option :value="30">30</option>
        <option :value="45">45</option>
      </select>
      <select class="w-20 border rounded px-2 py-2 text-sm" v-model="local.ampm">
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  </div>
</template>

<script>
import { reactive, watch } from "vue";

export default {
  name: "IntervalSelector",
  props: {
    label: {
      type: String,
      default: ""
    },
    valor: {
      type: Object,
      required: true
    }
  },
  emits: ["update"],
  setup(props, { emit }) {
    const local = reactive({
      hora: props.valor.hora,
      minuto: props.valor.minuto,
      ampm: props.valor.ampm
    });

    watch(
      () => ({ ...local }),
      (nuevo) => emit("update", { ...nuevo }),
      { deep: true }
    );

    watch(
      () => props.valor,
      (nuevo) => {
        local.hora = nuevo.hora;
        local.minuto = nuevo.minuto;
        local.ampm = nuevo.ampm;
      },
      { deep: true }
    );

    return { local };
  }
};
</script>
